import m from "../../../../geodata/es2015/region/usa/nmHigh";
window.am4geodata_region_usa_nmHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/nmHigh.js
// module id = null
// module chunks = 